(() => {
  const EOL_TAG = 'EOL';
  const CARD_SELECTORS = [
    '.main-products-grid__results li',
    '.featured-collection-products li',
    '[data-search-results] li',
    '.predictive-search li',
    '.recommendations li'
  ].join(',');

  const getHandle = (card) => {
    const link = card.querySelector('a[href*="/products/"]');
    if (!link) return null;
    const match = link.getAttribute('href').match(/\/products\/([^?#/]+)/);
    return match ? match[1] : null;
  };

  const cache = new Map();

  const isEol = async (handle) => {
    if (cache.has(handle)) return cache.get(handle);
    const request = fetch(`/products/${handle}.js`, { credentials: 'same-origin' })
      .then((response) => response.ok ? response.json() : null)
      .then((product) => Array.isArray(product?.tags) && product.tags.some((tag) => String(tag).toUpperCase() === EOL_TAG))
      .catch(() => false);
    cache.set(handle, request);
    return request;
  };

  const filterCards = async (root = document) => {
    const cards = [...root.querySelectorAll(CARD_SELECTORS)];
    await Promise.all(cards.map(async (card) => {
      if (card.dataset.pwEolChecked === 'true') return;
      card.dataset.pwEolChecked = 'true';
      const handle = getHandle(card);
      if (!handle) return;
      if (await isEol(handle)) {
        card.hidden = true;
        card.setAttribute('aria-hidden', 'true');
        card.classList.add('pw-eol-hidden');
      }
    }));
  };

  const run = () => filterCards();
  document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', run);
  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType === 1) filterCards(node);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
